<template>
  <div>
      <modal 
      name="addAuthSignatoryModal" 
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="700px"
      height="auto">
      <div class="v-modal">
          <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">Add Authorized Signatory</h2>
              <span @click="$modal.hide('addAuthSignatoryModal');closeNewSignatoryPopUp()">
              <em class="material-icons">close</em>
              </span>
          </div>
          <form  @submit.prevent data-vv-scope="beneficiaryform">
           <div class="form-container">
                          <div class="vx-row" @keyup="formerrors.msg=''" @click="formerrors.msg=''" > 
                            <template v-if="this.getTenantTypeId == 1 && [3,50].indexOf(this.getUserRoleId) > -1">
                            <immiInput :wrapclass="'md:w-full'" formscope="beneficiaryform" :cid="'benf'" v-model="title"  :display="false" :tplkey="'title'" :tplsection="''"   :required="true" :fieldName="'title'" label="Title/Designation" placeHolder="Title" /> 
                          </template>
                            <immiInput :wrapclass="'md:w-1/2'" formscope="beneficiaryform" :cid="'benf'" v-model="authSignatoryDetails.firstName"  :display="false" :tplkey="'firstName'" :tplsection="''"   :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                             <immiInput ::wrapclass="'md:w-1/2'" formscope="beneficiaryform" :cid="'benm'" v-model="authSignatoryDetails.lastName" :display="false" :tplkey="'lastName'" :tplsection="''"   :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                              <immiInput :wrapclass="'md:w-1/2'"  :display="false"  v-model="authSignatoryDetails.email"  :tplkey="'email'" datatype="email" cid="benfemail" formscope="beneficiaryform"  :required="true" :tplsection="''"  :fieldName="'email'"  label="Email" placeHolder="Email" />
                            <immiPhone :wrapclass="'md:w-1/2 phonenumber_sm'" :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="updatePhoneCountryCode" :countrycode="authSignatoryDetails.phoneCountryCode.countryCode" cid="bencellPhoneNumber" formscope="beneficiaryform" v-model="authSignatoryDetails.phone" :tplsection="''"  :fieldName="'cellPhoneNumber'" :required="true" label="Phone Number" placeHolder="Phone Number" />
                     </div>
                     <template v-if="this.getTenantTypeId == 2 && [3,4,5,6,8,7].indexOf(this.getUserRoleId) > -1">
                      <div class="vx-col  w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <label for="" class="form_label">Branch<em>*</em></label>
                            <multiselect name="branch" data-vv-as="Branch" v-validate="'required'" v-model="selectedBranches"
                              :show-labels="false" track-by="name" label="name" placeholder="Select Branch" :options="branchList"
                              :searchable="true" :allow-empty="true" :multiple="true" :hideSelected="true" :preselect-first="false"
                              :key="'branch-branch'">
                              <template slot="selection" slot-scope="{ values, isOpen }">
                                  <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                    Branch(s) Selected</span>
                                  <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                </template>
                            </multiselect>
                          </div>
                          <span class="text-danger text-sm"
                            v-if="errors.has('beneficiaryform.branch')">{{ errors.first("beneficiaryform.branch") }}</span>
                          <span class="text-danger text-sm" v-else-if="branchError">{{ branchError }}</span>
                        </div>
                    </div>
                     </template>
                    <template v-if="this.getTenantTypeId == 1 && [3,50].indexOf(this.getUserRoleId) > -1">
                      <div class="vx-col w-full pp-col">
                        <vs-checkbox id="signer" name="defaultSigner" v-model="defaultSigner" :key="'default-signer'">Select as default
                        </vs-checkbox>
                      </div>  
                  </template>
                     <!-- <div class="vx-col w-full">
                        <div > -->
                            <!-- <h3 class="small-header pt-2"> Address</h3> -->
                            <!-- <addressFields v-if="countries.length > 0" :prefiilAddress="false" :addFormContainerCls="false" :validationRequired="false"
                            :showaptType="true" :countries="countries" v-model="authSignatoryDetails.address" :cid="'add'" 
                            :showAPTCheckBox="false" formscope="beneficiaryform"/> -->
                            <!-- <addressFields  :wrapclass="'pad0'" v-if="countries.length > 0"  :prefiilAddress="false" :hideusa="false" :validationRequired="false" :disableCountry="false" formscope="'beneficiaryform'" :showaptType="true" :addFormContainerCls="false" :countries="countries"  v-model="authSignatoryDetails.address" :cid="'add'" /> -->

                        <!-- </div>
                    </div> -->
           </div>
           <div class="popup-footer relative">
             <figure v-if="submitForm" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
           <vs-button color="dark" @click="closeNewSignatoryPopUp();submitForm=false" class="cancel" type="filled">Cancel</vs-button>
           <vs-button color="success" :disabled="submitForm" @click="saveAuthSignatory" class="save" type="filled">Submit</vs-button>
           </div>
       </form>
      </div>
      </modal>
  </div>
</template>

   <script>
     import immiInput from "@/views/forms/fields/simpleinput.vue";
     import immiPhone from "@/views/forms/fields/phonenumber.vue";
     import addressFields from "@/views/forms/fields/address.vue"; 
   
     export default {
         components:{
             immiInput,
             immiPhone,
             addressFields,
         },
         provide() {
             return {
                 parentValidator: this.$validator,
             };
         },
         data(){
           return{
            title:'',
            defaultSigner:false,
            selectedBranches: [],
            branchList:[],
             formerrors: {
                 msg: ""
             },
             countries: [],
             submitForm:false,
             authSignatoryDetails:{
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "name": "",
                "email": "",
                "phone": "",
                "phoneCountryCode": {
                    "countryCode": "",
                    "countryCallingCode": ""
                },
            },
           }
         },
         methods:{ 
          getBranchList() {
            this.branchList = [];
            let item = {
              filters: {
                "title": '',
                "createdDateRange": [],
                "statusList": [],
                "activeList": [],
                "countryIds": [],
                "stateIds": [],
                "locationIds": []


              },
              getMasterData: true,
              page: 1,
              perpage: 1000,
              sorting: { "path": "createdOn", "order": -1 },

            };
            this.$store
              .dispatch("getList", { "data": item, "path": "/branch/list" })
              .then(response => {

                this.branchList = response.list;
              }).catch((error) => {
                this.branchList = [];
              })
        },
            closeNewSignatoryPopUp(data = null){
             this.$emit('closeNewSignatoryPopUp', data)
             this.$modal.hide('addAuthSignatoryModal');
           },
           updatePhoneCountryCode(data){
             this.authSignatoryDetails.phoneCountryCode =data;  
           },
           saveAuthSignatory() {
           this.$validator.validateAll('beneficiaryform').then(result => {
             if(result){
              let firstname = this.authSignatoryDetails['firstName'].trim();
              let lastname = this.authSignatoryDetails['lastName'].trim();
              this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { name: firstname + ' ' + lastname });
              this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "firstName": firstname });
              this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "lastName": lastname });

              if([50,51].indexOf(this.getUserRoleId) == -1 && this.getTenantTypeId == 1){
                this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "petitionerId": this.checkProperty(this.caseDetails, 'petitionerId')});
              }
              if([3,50].indexOf(this.getUserRoleId) > -1 && this.getTenantTypeId == 1){
                this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "defaultSigner": this.defaultSigner});
                this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "title": this.title});
              }
              if(this.getTenantTypeId == 2 && [3,4,5,6,8,7].indexOf(this.getUserRoleId) > -1 ){
                this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "roleId": 12});
                if (this.selectedBranches != []) {
                  this.authSignatoryDetails = Object.assign(this.authSignatoryDetails, { "branchIds": this.selectedBranches.map((item) => item._id) });
                }
              }
                let postData =this.authSignatoryDetails;
                this.submitForm=true
                let path = this.getTenantTypeId == 1 ? "/company/create-auth-signer" : "/users/register"
               this.$store
                 .dispatch("commonAction", {"data":postData ,"path":path})
                 .then(response => {
                    this.showToster({message:response.message,isError:false });
                   this.submitForm =false;
                    let obj = {
                        "_id": this.checkProperty(response, '_id'),
                        "title": this.checkProperty(response, 'title'),
                        "firstName": this.checkProperty(response, 'firstName'),
                        "middleName": this.checkProperty(response, 'middleName'),
                        "lastName": this.checkProperty(response, 'lastName'),
                        "name": this.checkProperty(response, 'name'),
                        "email": this.checkProperty(response, 'email'),
                        "phone": this.checkProperty(response, 'phone'),
                        "phoneCountryCode": this.checkProperty(response, 'phoneCountryCode'),
                    }
                  this.closeNewSignatoryPopUp(obj)
                  this.$modal.hide('addAuthSignatoryModal');
                 })
                 .catch((error)=>{
                  this.showToster({message:error,isError:true });
                   this.submitForm =false;
                   Object.assign(this.formerrors, {
                       msg:error
                     });
                 })
             }
           });
         },
         
   
         },
         mounted(){
          if(this.getTenantTypeId == 2 && [3,4,5,6,8,7].indexOf(this.getUserRoleId) > -1 ){
            this.getBranchList()
          }  
           this.$store.dispatch("getcountries").then((response) => {
                   this.countries = response;
               });
             this.$modal.show('addAuthSignatoryModal');
         },
         props:{
        caseDetails:null
        }
     }
   
   
   </script>